/** Stable binary min-heap for finite route searches. */
export class MinQueue<T> {
  private entries: { value: T; cost: number; order: number }[] = [];
  private serial = 0;
  get size(): number {
    return this.entries.length;
  }
  push(value: T, cost: number): void {
    const item = { value, cost, order: this.serial++ };
    let i = this.entries.length;
    this.entries.push(item);
    while (i) {
      const p = (i - 1) >> 1;
      if (!this.before(item, this.entries[p])) break;
      this.entries[i] = this.entries[p];
      i = p;
    }
    this.entries[i] = item;
  }
  pop(): { value: T; cost: number } | undefined {
    const first = this.entries[0],
      last = this.entries.pop();
    if (!first || !last) return first;
    if (this.entries.length) {
      let i = 0;
      while (i * 2 + 1 < this.entries.length) {
        let child = i * 2 + 1;
        if (child + 1 < this.entries.length && this.before(this.entries[child + 1], this.entries[child]))
          child++;
        if (!this.before(this.entries[child], last)) break;
        this.entries[i] = this.entries[child];
        i = child;
      }
      this.entries[i] = last;
    }
    return first;
  }
  private before(a: { cost: number; order: number }, b: { cost: number; order: number }): boolean {
    return a.cost < b.cost || (a.cost === b.cost && a.order < b.order);
  }
}
